var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.13757 12.8329C0.843356 12.85 0.554009 12.7522 0.330541 12.5601C-0.11018 12.1167 -0.11018 11.4007 0.330541 10.9574L9.9809 1.3072C10.4393 0.878283 11.1586 0.902126 11.5875 1.36051C11.9754 1.77502 11.998 2.41213 11.6404 2.85306L1.93322 12.5601C1.71263 12.7494 1.42793 12.847 1.13757 12.8329Z",
    fill: "#212A37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.776 12.8328C10.4779 12.8315 10.1921 12.7131 9.98035 12.5031L0.32996 2.85293C-0.0783459 2.37613 -0.0228346 1.65858 0.453971 1.25025C0.879533 0.885822 1.50715 0.885822 1.93268 1.25025L11.6399 10.9004C12.0982 11.3295 12.1219 12.0488 11.6928 12.507C11.6757 12.5253 11.6581 12.5429 11.6399 12.56C11.4022 12.7667 11.0894 12.8654 10.776 12.8328Z",
    fill: "#212A37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeCloseIcon);
export default __webpack_public_path__ + "static/media/intake-close-icon.415d2c864c001e78bf40b0c3e60e88a1.svg";
export { ForwardRef as ReactComponent };